const apiBaseUrl = process.env.NEXT_PUBLIC_API_BASE_URL ?? 'http://127.0.0.1:8787';

export type EvaluationLineBoardUserItem = {
  id: string;
  name: string;
  email: string;
  roleId: number;
  roleName: string;
  department: string | null;
  isActive: boolean;
};

export type EvaluationLineBoardEvaluatorItem = {
  userId: string;
  createdAt: string;
};

export type EvaluationLineBoardRelationItem = {
  evaluatorUserId: string;
  evaluateeUserId: string;
  createdAt: string;
};

export type EvaluationLineBoardResponse = {
  users: EvaluationLineBoardUserItem[];
  evaluators: EvaluationLineBoardEvaluatorItem[];
  relations: EvaluationLineBoardRelationItem[];
};

async function throwIfNotOk(response: Response) {
  if (response.ok) return;
  const payload = await response.json().catch(() => ({}));
  const message =
    typeof payload.message === 'string' ? payload.message : 'API request failed';
  throw new Error(message);
}

export async function fetchEvaluationLineBoard() {
  const response = await fetch(`${apiBaseUrl}/api/admin/evaluation-lines/board`);
  await throwIfNotOk(response);
  return (await response.json()) as EvaluationLineBoardResponse;
}

export async function createEvaluationEvaluator(input: { userId: string }) {
  const response = await fetch(`${apiBaseUrl}/api/admin/evaluation-lines/evaluators`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(input),
  });
  await throwIfNotOk(response);
}

export async function deleteEvaluationEvaluator(userId: string) {
  const response = await fetch(`${apiBaseUrl}/api/admin/evaluation-lines/evaluators/${userId}`, {
    method: 'DELETE',
  });
  await throwIfNotOk(response);
}

export async function upsertEvaluationLine(input: {
  evaluatorUserId: string;
  evaluateeUserId: string;
}) {
  const response = await fetch(`${apiBaseUrl}/api/admin/evaluation-lines`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(input),
  });
  await throwIfNotOk(response);
}

export async function removeEvaluationLineByEvaluatee(evaluateeUserId: string) {
  const response = await fetch(`${apiBaseUrl}/api/admin/evaluation-lines/${evaluateeUserId}`, {
    method: 'DELETE',
  });
  await throwIfNotOk(response);
}
